import React from "react";
import { useNavigate } from "react-router-dom";

const CompanyPage = () => {
  const navigate = useNavigate();

  // Navigation handlers
  const handleStructureClick = () => navigate("/structure");
  const handleDepartmentsClick = () => navigate("/departments");
  const handleDesignationClick = () => navigate("/designation");
  const handleEventsClick = () => navigate("/event");
  const handleAnnouncementsClick = () => navigate("/announcement");

  return (
    <div className="p-4 sm:p-6 lg:p-8 bg-gradient-to-r from-blue-800 to-indigo-900 min-h-screen">
      <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-40 text-center">
        Company Management
      </div>

      {/* Company Options */}
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
          {/* Structure Card */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden transform transition-all hover:shadow-xl hover:scale-105 cursor-pointer" onClick={handleStructureClick}>
            <div className="bg-gradient-to-r from-green-500 to-green-600 p-4">
              <h2 className="text-xl font-bold text-white text-center">Structure</h2>
            </div>
            <div className="p-5 flex flex-col items-center">
              <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
              </div>
              <p className="text-center text-gray-600">Manage your company's organizational structure</p>
            </div>
          </div>

          {/* Departments Card */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden transform transition-all hover:shadow-xl hover:scale-105 cursor-pointer" onClick={handleDepartmentsClick}>
            <div className="bg-gradient-to-r from-blue-500 to-blue-600 p-4">
              <h2 className="text-xl font-bold text-white text-center">Departments</h2>
            </div>
            <div className="p-5 flex flex-col items-center">
              <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <p className="text-center text-gray-600">Manage company departments and teams</p>
            </div>
          </div>

          {/* Designation Card */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden transform transition-all hover:shadow-xl hover:scale-105 cursor-pointer" onClick={handleDesignationClick}>
            <div className="bg-gradient-to-r from-purple-500 to-purple-600 p-4">
              <h2 className="text-xl font-bold text-white text-center">Designation</h2>
            </div>
            <div className="p-5 flex flex-col items-center">
              <div className="w-20 h-20 bg-purple-100 rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <p className="text-center text-gray-600">Manage employee designations and roles</p>
            </div>
          </div>

          {/* Events Card */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden transform transition-all hover:shadow-xl hover:scale-105 cursor-pointer" onClick={handleEventsClick}>
            <div className="bg-gradient-to-r from-red-500 to-red-600 p-4">
              <h2 className="text-xl font-bold text-white text-center">Events</h2>
            </div>
            <div className="p-5 flex flex-col items-center">
              <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
              <p className="text-center text-gray-600">Manage company events and holidays</p>
            </div>
          </div>

          {/* Announcements Card */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden transform transition-all hover:shadow-xl hover:scale-105 cursor-pointer" onClick={handleAnnouncementsClick}>
            <div className="bg-gradient-to-r from-amber-500 to-amber-600 p-4">
              <h2 className="text-xl font-bold text-white text-center">Announcements</h2>
            </div>
            <div className="p-5 flex flex-col items-center">
              <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-amber-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z" />
                </svg>
              </div>
              <p className="text-center text-gray-600">Manage company announcements and updates</p>
            </div>
          </div>
        </div>

        {/* Back Button */}
        <div className="mt-72 text-center">
          <button 
            onClick={() => navigate("/dashboard")}
            className="bg-white text-blue-700 px-6 py-2 rounded-lg shadow hover:bg-gray-100 transition-colors font-medium"
          >
            Back to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default CompanyPage;